import {GroupFilterContext} from 'context/groupFilterContext';
import {useTranslation} from 'hooks/translations/useCustomTranslation';
import {useContext, useEffect} from 'react';
import {Controller, useFormContext} from 'react-hook-form';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Checkbox, FormControlLabel, Theme, useMediaQuery} from '@mui/material';

import {palette} from 'styles/mui/scss';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from 'components/basic-components';

import styles from './styles/CarFilterSelectRadio.module.scss';
import {countProperties} from './utils/countProperties';

const CarFilterSelect = ({filter = [], title, inputName, data}) => {
  const {t} = useTranslation('groupType');
  const displayFilter = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const {control, getValues, setValue} = useFormContext();
  const {initialized} = useContext(GroupFilterContext);
  const formValues = getValues();
  useEffect(() => {
    const newValue = formValues[inputName].filter(name => {
      return countProperties(name, data, inputName, formValues.type);
    });
    if (newValue.length !== formValues[inputName].length && initialized) {
      setValue(inputName, newValue);
    }
  }, [formValues]);
  // console.log(filter);
  if (!filter) return null;
  return (
    <Controller
      control={control}
      name={inputName}
      defaultValue={[]}
      render={({field: {value, onChange}}) => (
        <Box>
          <Accordion defaultExpanded={displayFilter} variant="mobile">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className={styles.icon} />}
              aria-controls="panel2a-content"
            >
              <Typography className={styles.accordionTitle}>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box className={styles.detailsWrapper}>
                {filter.map((type, index) => {
                  const {name = '', label = ''} =
                    typeof type === 'string' && type !== null ? {label: type, name: type} : type;
                  const count = countProperties(name, data, inputName, formValues.type);
                  return (
                    <FormControlLabel
                      className={styles.formControlLabel}
                      sx={{
                        '& .MuiFormControlLabel-label': {width: '100%'},
                      }}
                      key={index}
                      control={
                        <Checkbox
                          sx={{
                            '& *': {color: count === 0 ? palette.colorGrey20 : palette.colorGrey80},
                          }}
                          className={styles.controlElement}
                          disabled={count === 0}
                          checked={
                            (inputName !== 'minAge' && value.includes(name)) ||
                            (inputName === 'minAge' && name !== 25 && value.includes(name)) ||
                            (inputName === 'minAge' &&
                              name === 25 &&
                              value.includes(name) &&
                              formValues.minAge.length === 1)
                          }
                          onChange={e => {
                            const isChecked = e.target.checked;
                            if (isChecked) {
                              onChange([...value, name]);
                            } else {
                              onChange(value.filter(item => item !== name));
                            }
                          }}
                        />
                      }
                      label={
                        <Box className={styles.labelWrapper}>
                          <Typography
                            sx={{color: count === 0 ? palette.colorGrey20 : palette.colorGrey80}}
                            className={styles.label}
                          >
                            {inputName === 'type' ? t(label) : label}
                          </Typography>
                          <Typography className={styles.count}>{count}</Typography>
                        </Box>
                      }
                    ></FormControlLabel>
                  );
                })}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
      )}
    />
  );
};

export default CarFilterSelect;
